export class AddGlobalAddressWhitelistRequest {
    Address: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
}
